export default "__VITE_ASSET__CStymI9K__"